import { Location } from "@angular/common";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "fury-callrail-lead-details",
  templateUrl: "./callrail-lead-details.component.html",
  styleUrls: ["./callrail-lead-details.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CallrailLeadDetailsComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    private location: Location
  ) {}
  ngUnsubscribe = new Subject<void>();
  callRailLead: any = null;
  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params) => {
        this.getCallRailLead(params?.id);
      });
  }

  getCallRailLead(id) {
    this.apiService
      .get(endpoints.leadManagement.getCallRailLead(id))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.callRailLead = res.body?.callRailLead;
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  back() {
    this.location.back()
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
